/*
  Normalizes text read from a selection / highlight to a canonical form: strips the Word-Joiner
  (U+2060) our highlight resize handles inject, collapses runs of whitespace to a single space, and
  trims. Used both to compare two pieces of text without being thrown off by handles or insignificant
  whitespace, and to test whether a selection is effectively blank.
*/
export default function normalizeSelectionText(text: string): string {
  return text.replace(/\u2060/g, '').replace(/\s+/g, ' ').trim();
}
